import { render, staticRenderFns } from "./glob-params.vue?vue&type=template&id=61400b38"
import script from "./glob-params.vue?vue&type=script&lang=js"
export * from "./glob-params.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports